import { Tooltip } from '@sgme/ui';
import classNames from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const ThumbnailImg = styled.a<{ $backgroundImageUrl?: string; $dim: number; $float: 'left' | 'none' }>`
  background-color: var(--bs-bg-lvl2);
  background-image: ${props => (props.$backgroundImageUrl ? `url(${props.$backgroundImageUrl})` : 'none')};
  background-size: contain;
  display: block;
  max-height: ${props => `${props.$dim}px`};
  min-height: ${props => `${props.$dim}px`};
  min-width: ${props => `${props.$dim}px`};
  float: ${props => props.$float};
  background-repeat: no-repeat;
  background-position: center;
`;

export interface TopTradesItemProps {
  title: string;
  content: string;
  documentLink?: string;
  pictureLink?: string;
  pictureUrl?: string;

  dimension: 'sm' | 'lg';
  className?: string;
}

const ContentDiv = styled.div`
  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const TopTradesItem: FC<TopTradesItemProps> = ({
  title,
  content,
  documentLink,
  pictureLink,
  pictureUrl,
  dimension,
}) => {
  return (
    <div className="col-12">
      <div
        className={classNames(
          'row ',
          dimension === 'lg' ? ' my-2 border-bottom' : ' border-bottom  ps-md-3 pe-3 pb-1 mt-1  mb-2',
        )}
      >
        {pictureUrl && (
          <div
            className={classNames(
              'col-md-4 ',
              dimension === 'lg' ? 'col-12 px-0  my-2 pe-md-4' : 'col-4 pb-1  my-1  px-2 ',
            )}
          >
            <ThumbnailImg
              $dim={dimension === 'lg' ? 200 : 85}
              $backgroundImageUrl={pictureUrl}
              href={pictureLink}
              target="_blank"
              $float="none"
            />
          </div>
        )}
        <div className={classNames('col px-0', dimension === 'lg' ? '' : 'px-2')}>
          <div className="d-flex justify-content-between">
            {dimension === 'lg' ? <h2>{title}</h2> : <h5>{title}</h5>}
            {documentLink && (
              <Tooltip position="top" contents={<FormattedMessage id="downloadDocument" />}>
                <a href={documentLink} target="_blank">
                  <i className={`icon icon-${dimension} me-2`}>picture_as_pdf</i>
                </a>
              </Tooltip>
            )}
          </div>
          {content && (
            <ContentDiv
              className={classNames('card-text text-start', dimension === 'lg' ? 'text-large pb-3' : '')}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const TopTradesItemSkeleton: FC<{ lines: number }> = ({ lines }) => (
  <>
    <h4>
      <Skeleton width="15em" />
    </h4>
    <p className="card-text text-start">
      <Skeleton count={lines} />
    </p>
  </>
);
